import { FC } from 'react';
import { useRouter } from 'next/router';
import { IAutoInvestContract } from '@/services/apis/paymentService/types';
import { ScheduleRowCard } from '@/common/components/ScheduleRowCard';
import { useGetUserContractFund } from '../hooks/useGetUserContractFund';
import { getContractChipVariant } from '@/modules/auto-invest/utils/getContractChipVariant';
import { getSchedulesDescription } from '@/modules/auto-invest/utils/getSchedulesDescription';
import { EmptyState } from './EmptyState';

export const List: FC = () => {
  const { data, hasUserContractFund } = useGetUserContractFund({
    enabled: false,
  });

  const { push } = useRouter();

  const handleScheduleRowCardClick = (contract: IAutoInvestContract) => () => {
    push(`/auto-invest/schedules/${contract.trackingId}`);
  };

  if (!hasUserContractFund) {
    return <EmptyState />;
  }

  return (
    <>
      {data?.items.map((contract) => {
        const variant = getContractChipVariant(contract.status);

        const schedulesDescription = getSchedulesDescription(
          contract.scheduleList
        );

        return (
          <ScheduleRowCard
            key={contract.trackingId}
            amount={contract.amount}
            destinationLogo={contract.destinationLogo}
            destinationTitle={contract.destinationTitle}
            schedulesDescription={schedulesDescription}
            sourceLogo={contract.sourceLogo}
            sourceTitle={contract.sourceTitle}
            statusTitle={contract.statusTitle}
            variant={variant}
            onClick={handleScheduleRowCardClick(contract)}
          />
        );
      })}
    </>
  );
};
